import p4 from "../components/image/project/ArtInstitute-Dom.jpg"
import p5 from "../components/image/project/Harry-Dom.jpg"
import p6 from "../components/image/project/makeUp-Dom.jpg"
import p7 from "../components/image/project/cart-React.jpg"
import p9 from "../components/image/project/Crud-React.jpg"
import p8 from "../components/image/project/Harry-React.jpg"
import p11 from "../components/image/project/pizzaApp.jpg"
import p12 from "../components/image/project/Capstone.jpg"
import p13 from "../components/image/project/Shine.png"
import p14 from "../components/image/project/AkjStores.png"
import p15 from "../components/image/project/IMDB_Admin.jpg"
import p16 from "../components/image/project/IMDB_User.jpg"
import js from "../components/image/logo/js-logo.webp"



 export const project=[
    {
        title:"IMDB Clone Admin UI ( FullStack )",
        title2:"IMDB Admin UI",
        image:p16,
        netlify:"https://imdb-admi-ui.netlify.app/",
        frontEnd:"https://github.com/mohamedsalahudeen010/IMDB-Admin-UI",
        backEnd:"https://github.com/mohamedsalahudeen010/IMDB-Server",
        tech:["Javascript","HTML","CSS","React","NodeJs","Express","MongoDB","Mongoose","Context API","Redux","Boostrap","Material UI","Formik-Yup"],
        description:`This Application is a MERN Full stack Application of IMDB clone Admin UI, Provides
        list of Movies with ratings,The platform includes user authentication,
        product listing, search functionality, includes Bcrypt Authentication and
        Json Web Token (JWT) Authorization.`
    },
    {
        title:"IMDB Clone User UI ( FullStack )",
        title2:"IMDB User UI",
        image:p15,
        netlify:"https://imdb-user-ui.netlify.app/",
        frontEnd:"https://github.com/mohamedsalahudeen010/IMDB-User-UI",
        backEnd:"https://github.com/mohamedsalahudeen010/IMDB-Server",
        tech:["Javascript","HTML","CSS","React","NodeJs","Express","MongoDB","Mongoose","Context API","Redux","Boostrap","Material UI","Formik-Yup"],
        description:`This Application is a MERN Full stack Application of IMDB clone User UI, Provides
        list of Movies with ratings,The platform includes user authentication,
        product listing, search functionality, includes Bcrypt Authentication and
        Json Web Token (JWT) Authorization.`
    },
    {
        title:"E-Commerce Application ( FullStack )",
        title2:"E-Commerce App",
        image:p14,
        netlify:"https://akjstores.netlify.app/",
        frontEnd:"https://github.com/mohamedsalahudeen010/AKJ-Stores",
        backEnd:"https://github.com/mohamedsalahudeen010/AKJBackEnd",
        tech:["Javascript","HTML","CSS","React","NodeJs","Express","MongoDB","Mongoose","Context API","Redux","Boostrap","Material UI","Formik-Yup"],
        description:"This Application is a MERN Full stack Application for E commerce App, This application has products for users and stock updation for admin, It includes CRUD operations, includes Bcrypt Authentication and Json Web Token (JWT) Authorization."
    },
    {
        title:"Paint Shop Application ( FullStack )",
        title2:"Paint Shop App",
        image:p13,
        netlify:"https://shinetraders-app.netlify.app/",
        frontEnd:"https://github.com/mohamedsalahudeen010/shineTraders",
        backEnd:"https://github.com/mohamedsalahudeen010/shineTraders-backEnd",
        tech:["Javascript","HTML","CSS","React","NodeJs","Express","MongoDB","Mongoose","Context API","Redux","Boostrap","Formik-Yup"],
        description:"This Application is a MERN Full stack Application for Paint Shop, This application has products for users and stock updation for admin, It includes CRUD operations, includes Bcrypt Authentication and Json Web Token (JWT) Authorization."
    },
    
    {
        title:"Gold Rate Convertor Application ( FullStack )",
        title2:"Gold Rate Convertor",
        image:p12,
        netlify:"https://tourmaline-figolla-345c51.netlify.app/",
        frontEnd:"https://github.com/mohamedsalahudeen010/Capstone-FrontEnd",
        backEnd:"https://github.com/mohamedsalahudeen010/Capstone-BackEnd",
        tech:["Javascript","HTML","CSS","React","NodeJs","Express","MongoDB","Mongoose","Context API","Redux","Boostrap","Formik-Yup"],
        description:"This Application is a Gold Rate Convertor MERN Full stack Application, assigned as a Capstone project, Welcome to the Gold Rate Convertor Application, a Web page designed to help you determine Gold prices using various weights, karats (e.g., 24K, 22K, 21K, 18K etc.), and currencies from around the world, includes Bcrypt Authentication and Json Web Token (JWT) Authorization."
    },

    {
        title:"Pizza Ordering Application ( FullStack )",
        title2:"Pizza Shop App",
        image:p11,
        netlify:"https://shimmering-mochi-ffa38e.netlify.app/",
        frontEnd:"https://github.com/mohamedsalahudeen010/WebCode-2-FrontEnd",
        backEnd:"https://github.com/mohamedsalahudeen010/webcode-2-Backend",
        tech:["Javascript","HTML","CSS","React","NodeJs","Express","MongoDB","Mongoose","Context API","Redux","Boostrap","Formik-Yup"],
        description:"This Application is a Pizza ordering MERN Full stack Application, assigned as a Webcode project, this contains user pizza ordering Interface and stock updation for Admin,Explore the menu for your favourite veg & non-veg pizzas and you can add toppings, includes Bcrypt Authentication and Json Web Token (JWT) Authorization."
    },
   
    {
        title:"Students Crud Application ( FullStack )",
        title2:"Students Crud App",
        image:p9,
        netlify:"https://roaring-kheer-e775dc.netlify.app/",
        frontEnd:"https://github.com/mohamedsalahudeen010/Crud-Basic-app",
        backEnd:"https://github.com/mohamedsalahudeen010/Basic-Crud-BackEnd-",
        tech:["Javascript","HTML","CSS","React","NodeJs","Express","MongoDB","Boostrap","Formik-Yup"],
        description:"This Application is a MERN Full stack Application, This Application has CRUD operations to maintain Students data of School, includes Bcrypt Authentication and Json Web Token (JWT) Authorization."
    },
    
    {
        title:"Harry Potter School Crud Application",
        title2:"Harry Potter App",
        image:p8,
        netlify:"https://relaxed-twilight-d309ee.netlify.app/",
        frontEnd:"https://github.com/mohamedsalahudeen010/Crud-React--Formik",
        tech:["Javascript","HTML","CSS","Boostrap","React","Formik-Yup"],
        description:"This Application is a React Front End application, This Application has CRUD operations to maintain Teachers and Students data of Hogwarts School."
    }
    
    // {
    //     title:"Product Cart Application",
    //     title2:"Product Cart App",
    //     image:p7,
    //     netlify:"https://cool-sunburst-d44a0e.netlify.app/",
    //     frontEnd:"https://github.com/mohamedsalahudeen010/Sports-Cart-React-",
    //     tech:["Javascript","HTML","CSS","Boostrap","React"],
    //     description:"This Application is a React Front End application, This Application contains product card and add to cart User Interface."
    // },
  
    // {
    //     title:"MakeUp Shop Application",
    //     title2:"MakeUp Shop App",
    //     image:p6,
    //     netlify:"https://eclectic-salamander-afb833.netlify.app",
    //     frontEnd:"https://github.com/mohamedsalahudeen010/Webcode---B42",
    //     tech:["Javascript","HTML","CSS","DOM","Boostrap"],
    //     description:"This Application is a Front End application built by using DOM, Assigned as a WebCode Project, This Application contains User Interface for Makeup store. "
    // },
    
    // {
    //     title:"Harry Potter Application",
    //     title2:"Harry Potter App",
    //     image:p5,
    //     netlify:"https://fluffy-sunshine-ceb9c8.netlify.app/",
    //     frontEnd:"https://github.com/mohamedsalahudeen010/Harry-Potter",
    //     tech:["Javascript","HTML","CSS","DOM","Boostrap"],
    //     description:"This Application is a Front End application built by using DOM,This Application contains User Interface for Students and teachers Data of Hogwarts school."
    // },
   
    // {
    //     title:"Art Institute Application",
    //     title2:"Art Institute App",
    //     image:p4,
    //     netlify:"https://lighthearted-cucurucho-100ecf.netlify.app",
    //     frontEnd:"https://github.com/mohamedsalahudeen010/Art-Institute-of-Chicago",
    //     tech:["Javascript","HTML","CSS","DOM","Boostrap"],
    //     description:"This Application is a Front End application built by using DOM,This Application contains User Interface for Art Institute of Chicaco Museum."
    // }
   
]
